import { useState } from 'react';
import { copyTextToClipboard } from '@vkontakte/vkjs';
import { Button } from '../Button';
import styles from './CopyLink.module.css';

interface CopyLinkProps {
  placeholder: string;
  url: string;
  buttonLabel: string;
  copiedLabel: string;
}

export function CopyLink(props: CopyLinkProps) {
  const { placeholder, url, buttonLabel, copiedLabel } = props;
  const [isCopied, setIsCopied] = useState(false);

  function handleCopy() {
    copyTextToClipboard(url);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  }

  return (
    <div className={styles.root}>
      <span className={styles.url}>{placeholder}</span>
      <Button onClick={handleCopy} mode={isCopied ? 'secondary' : 'primary'}>
        {isCopied ? copiedLabel : buttonLabel}
      </Button>
    </div>
  );
}
